import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { broadcastLogout } from '@/auth/logoutChannel';
import {
  hasLogoutStarted,
  setProfileIdentity,
  startLogout,
} from '@/auth/session';
import { STORED_OFFERS_SKIPPED_SESSION } from '@/auth/stored';
import { POST_LOGOUT_REDIRECT_URL } from '@/config/env';
import { ROUTE_ROOT } from '@/router/routes';
import { clearNewsGalleryImageCache } from '@/utils/newsGalleryImageCache';

export const useLogout = (): (() => Promise<void>) => {
  const { user, removeUser, signoutRedirect } = useAuth();

  return useCallback(async () => {
    if (hasLogoutStarted()) {
      return;
    }

    startLogout();
    broadcastLogout(user);
    sessionStorage.removeItem(STORED_OFFERS_SKIPPED_SESSION);
    setProfileIdentity(undefined);
    await clearNewsGalleryImageCache();

    try {
      await signoutRedirect();
    } catch {
      await removeUser();
      window.location.replace(POST_LOGOUT_REDIRECT_URL || ROUTE_ROOT);
    }
  }, [user, removeUser, signoutRedirect]);
};
